module.exports = __webpack_public_path__ + "img/ll.d345759.png";